import Carousel from "react-slick";

export { default as CarouselDots } from "./CarouselDots";
export { default as CarouselArrows } from "./CarouselArrows";
export { default as CarouselArrowIndex } from "./CarouselArrowIndex";

export default Carousel;
